import React from 'react';

interface ReconnectionBannerProps {
    onReconnect: () => void;
}

const ReconnectionBanner: React.FC<ReconnectionBannerProps> = ({ onReconnect }) => {
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                backgroundColor: '#ff6b6b',
                color: 'white',
                padding: '12px 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                zIndex: 10000,
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                animation: 'slideDown 0.3s ease-out'
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="10" cy="10" r="9" stroke="white" strokeWidth="2" />
                    <path d="M10 6V11" stroke="white" strokeWidth="2" strokeLinecap="round" />
                    <circle cx="10" cy="14" r="1" fill="white" />
                </svg>
                <span style={{ fontSize: '14px', fontWeight: 500 }}>
                    接続に失敗しました。インターネット接続を確認してください。
                </span>
            </div>

            <button
                onClick={onReconnect}
                style={{
                    backgroundColor: 'white',
                    color: '#ff6b6b',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '8px 16px',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#f8f8f8';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'white';
                }}
            >
                再接続
            </button>

            <style>{`
                @keyframes slideDown {
                    from {
                        transform: translateY(-100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }
            `}</style>
        </div>
    );
};

export default React.memo(ReconnectionBanner);